import {setupWorker} from 'msw/browser'

import {getHandlers} from './mockModules'

const mswHandlers = getHandlers()

export const mswWorker = setupWorker(...mswHandlers)
